import { combineReducers } from 'redux';
import authReducers from './actions/authActions/authReducer';
import nodeTreeReducers from './actions/treeActions/treeReducer';
import alarmsReducer from './actions/alarmsActions/alarmsReducers';
import configReducer from './actions/configActions/configReducers';
import usersReducer from './actions/usersActions/usersReducers';
import hardwareReducer from './actions/hardwareActions/hardwareReducers';
import ThemeOptions from './actions/themeActions';
import analyticsReducer from './actions/analyticsActions/analyticsReducer';
import eventsReducer from './actions/eventsActions/eventsReducers';
import errorLoggingReducer from './actions/errorLoggingActions/errorLoggingReducer';
import tagsReducer from './actions/tagsActions/tagsReducer';
import dateRange from '../main/platform/dashboards/components/dateRange/duck';
import dateGroup from '../main/platform/dashboards/components/dateGroup/duck';
import { pendingAPIReducer, pendingAPIReducerPath } from '../main/platform/dashboards/pendings/ducks';
import { notificationAPIReducer, notificationAPIReducerPath } from '../main/platform/dashboards/notifications/ducks';
import { analyticsAPIReducer, analyticsAPIReducerPath } from '../main/platform/dashboards/overview/ducks';
import {
    eventsAPIReducer,
    eventsAPIReducerPath,
    causesAPIReducer,
    causesAPIReducerPath,
} from '../main/platform/dashboards/overview/eventView/ducks';
import { versionAPIReducer, versionAPIReducerPath } from '../main/ducks';
import {
    maintenanceEventAPIReducer,
    maintenanceEventAPIReducerPath,
} from '../main/platform/dashboards/pendings/ducks/maintenanceEvent';
import {
    assetLifecycleAPIReducer,
    assetLifecycleAPIReducerPath,
} from '../main/platform/dashboards/pendings/ducks/assetLifecycle';
import { alarmsAPIReducer, alarmsAPIReducerPath } from '../main/platform/dashboards/alarms/ducks';
import { reportsAPIReducer, reportsAPIReducerPath } from '../main/platform/dashboards/reports/ducks';
import reportsDownload from '../main/platform/dashboards/reports/ducks/downloadDuck';
import dataDownload from '../main/platform/dashboards/configuration/ducks/downloadData';
import {
    hardwareAPIReducer,
    hardwareAPIReducerPath,
    hardwareLegacyAPIReducer,
    hardwareLegacyAPIReducerPath,
} from '../main/platform/dashboards/reports/ducks/hardwareDuck';
import {
    diagnosticsAPIReducer,
    diagnosticsAPIReducerPath,
    findingsAPIReducer,
    findingsAPIReducerPath,
    problemsAPIReducer,
    problemsAPIReducerPath,
} from '../main/platform/dashboards/analysis/ducks';
import { usersAPIReducer, usersAPIReducerPath } from '../main/platform/dashboards/User/ducks';
import { configurationAPIReducer, configurationAPIReducerPath } from '../main/platform/dashboards/configuration/ducks';
import { messagesAPIReducer, messagesAPIReducerPath } from '../main/platform/dashboards/inbound_messages/ducks';
import {
    bearingsAPIReducer,
    bearingsAPIReducerPath,
} from '../main/platform/dashboards/configuration/ducks/bearingsData';
import { dashboardsAPIReducer, dashboardsAPIReducerPath } from '../main/platform/dashboards/analytics/ducks';
import { feedAPIReducer, feedAPIReducerPath } from '../main/platform/dashboards/feed/ducks';
import { feedSelectionReducer } from '../main/platform/dashboards/feed/ducks/selectionDuck';
import {
    cardEventsAPIReducer,
    cardEventsAPIReducerPath,
} from '../main/platform/dashboards/components/cardEvents/ducks';
import {
    internationalizationAPIReducer,
    internationalizationAPIReducerPath,
} from '../main/platform/ducks/translations';
import { mediaAPIReducer, mediaAPIReducerPath } from '../main/platform/dashboards/overview/ducks/mediaDuck';
import {
    orientationAPIReducer,
    orientationAPIReducerPath,
} from '../main/platform/dashboards/analysis/ducks/orientationDuck';
import {
    bestPracticeAPIReducer,
    bestPracticeAPIReducerPath,
} from '../main/platform/dashboards/analysis/ducks/bestPracticeDuck';
import {
    installationAPIReducer,
    installationAPIReducerPath,
} from '../main/platform/dashboards/configuration/ducks/installations';
import { exportAPIReducer, exportAPIReducerPath } from '../main/platform/dashboards/diagnostics/ducks/export';
import {
    annotationsAPIReducer,
    annotationsAPIReducerPath,
} from '../main/platform/dashboards/analysis/ducks/annotationsDuck';
import { measurementsV3APIReducer, measurementsV3APIReducerPath } from '../main/platform/dashboards/analysis/ducks';
import {
    spectralBandsAPIReducer,
    spectralBandsAPIReducerPath,
} from '../main/platform/dashboards/analysis/ducks/spectralBandsDuck';
import { odmAPIReducer, odmAPIReducerPath } from '../main/platform/dashboards/analysis/ducks/odm';
import { devicesAPIReducer, devicesAPIReducerPath } from '../main/platform/dashboards/Hardware/ducks';
import { modelAPIReducer, modelAPIReducerPath } from '../main/platform/ducks/model';
import { authAPIReducer, authAPIReducerPath } from '../main/landing/ducks';
import { reviewAPIReducer, reviewAPIReducerPath } from '../main/platform/dashboards/analysis/ducks/review';
import {
    operationHoursAPIReducer,
    operationHoursAPIReducerPath,
} from '../main/platform/dashboards/summary/ducks/operationHoursApi';
import {
    offlineAnalysisAPIReducer,
    offlineAnalysisAPIReducerPath,
} from '../main/platform/dashboards/summary/ducks/offlineAnalysisApi';

const appReducer = combineReducers({
    authReducers,
    nodeTreeReducers,
    alarmsReducer,
    configReducer,
    usersReducer,
    hardwareReducer,
    ThemeOptions,
    analyticsReducer,
    eventsReducer,
    errorLoggingReducer,
    tagsReducer,
    dateRange,
    dateGroup,
    [pendingAPIReducerPath]: pendingAPIReducer,
    [notificationAPIReducerPath]: notificationAPIReducer,
    [eventsAPIReducerPath]: eventsAPIReducer,
    [causesAPIReducerPath]: causesAPIReducer,
    [analyticsAPIReducerPath]: analyticsAPIReducer,
    [versionAPIReducerPath]: versionAPIReducer,
    [maintenanceEventAPIReducerPath]: maintenanceEventAPIReducer,
    [assetLifecycleAPIReducerPath]: assetLifecycleAPIReducer,
    [alarmsAPIReducerPath]: alarmsAPIReducer,
    [reportsAPIReducerPath]: reportsAPIReducer,
    reportsDownload,
    dataDownload,
    [hardwareAPIReducerPath]: hardwareAPIReducer,
    [hardwareLegacyAPIReducerPath]: hardwareLegacyAPIReducer,
    [problemsAPIReducerPath]: problemsAPIReducer,
    [findingsAPIReducerPath]: findingsAPIReducer,
    [diagnosticsAPIReducerPath]: diagnosticsAPIReducer,
    [usersAPIReducerPath]: usersAPIReducer,
    [configurationAPIReducerPath]: configurationAPIReducer,
    [messagesAPIReducerPath]: messagesAPIReducer,
    [bearingsAPIReducerPath]: bearingsAPIReducer,
    [dashboardsAPIReducerPath]: dashboardsAPIReducer,
    [feedAPIReducerPath]: feedAPIReducer,
    feedSelection: feedSelectionReducer,
    [cardEventsAPIReducerPath]: cardEventsAPIReducer,
    [internationalizationAPIReducerPath]: internationalizationAPIReducer,
    [mediaAPIReducerPath]: mediaAPIReducer,
    [orientationAPIReducerPath]: orientationAPIReducer,
    [bestPracticeAPIReducerPath]: bestPracticeAPIReducer,
    [installationAPIReducerPath]: installationAPIReducer,
    [exportAPIReducerPath]: exportAPIReducer,
    [annotationsAPIReducerPath]: annotationsAPIReducer,
    [measurementsV3APIReducerPath]: measurementsV3APIReducer,
    [spectralBandsAPIReducerPath]: spectralBandsAPIReducer,
    [odmAPIReducerPath]: odmAPIReducer,
    [devicesAPIReducerPath]: devicesAPIReducer,
    [modelAPIReducerPath]: modelAPIReducer,
    [authAPIReducerPath]: authAPIReducer,
    [reviewAPIReducerPath]: reviewAPIReducer,
    [operationHoursAPIReducerPath]: operationHoursAPIReducer,
    [offlineAnalysisAPIReducerPath]: offlineAnalysisAPIReducer,
});

const rootReducer = (state, action) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === 'AUTH_LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
